var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 101,
    viewBox: "0 0 272 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 271,
    height: 100,
    rx: 4.5,
    fill: "",
    stroke: "#64748b85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.397 50.4292L202.399 50.4301C203.066 50.7638 203.721 51.0912 204.338 51.5121C205.939 52.6073 206.444 54.2079 206.192 55.9771C205.854 57.7883 204.254 59.5575 201.137 59.5575C199.915 59.5575 198.778 59.2206 197.725 58.4202C196.63 57.5777 196.209 56.6511 196.209 55.0083C196.209 54.9662 196.251 54.924 196.293 54.924H198.567C198.61 54.924 198.652 54.9662 198.652 55.0083C198.652 55.1768 198.694 55.5138 198.736 55.6822C199.073 56.6511 199.957 57.2829 201.137 57.3671C202.19 57.4513 203.243 56.8617 203.664 56.0192C204.085 55.0926 203.791 53.9131 202.737 53.2813C202.049 52.8404 200.549 52.057 199.499 51.509C198.944 51.2192 198.515 50.9952 198.399 50.9224C195.408 49.069 195.914 43.1719 201.474 43.1719C202.569 43.1719 203.58 43.5089 204.465 44.1828C205.391 44.8989 205.897 45.9941 206.023 47.2999C206.023 47.342 205.981 47.3841 205.939 47.3841H203.833C203.791 47.3841 203.748 47.342 203.748 47.2999C203.496 45.4044 201.179 44.8989 199.789 45.8256C198.778 46.4995 198.61 48.016 199.536 48.7742C200.027 49.1896 200.62 49.5036 201.193 49.807L201.389 49.9115C201.478 49.9591 201.565 50.0058 201.653 50.0517L201.728 50.0907L201.87 50.1636C202.046 50.2537 202.222 50.3416 202.397 50.4292Z",
    fill: "#CACACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.403 43.5089C106.446 43.5089 106.488 43.551 106.488 43.5931V59.389C106.488 59.4005 106.485 59.4121 106.479 59.4228C106.471 59.4397 106.456 59.4544 106.439 59.4635C106.428 59.4696 106.416 59.4732 106.403 59.4732H104.129C104.117 59.4732 104.104 59.4696 104.093 59.4635C104.085 59.4593 104.078 59.4538 104.072 59.4474C104.059 59.4355 104.05 59.4205 104.046 59.4048C104.045 59.3995 104.045 59.3943 104.045 59.389V47.3841C104.045 47.2577 103.918 47.2577 103.876 47.3421L101.981 53.5761L101.854 53.9973C101.854 53.9973 101.812 54.0395 101.77 54.0395H100.001C99.9712 54.0395 99.9413 54.0395 99.9265 54.0246C99.9204 54.0184 99.9167 54.0097 99.9167 53.9973L99.7904 53.5761L97.8949 47.3421C97.8527 47.2577 97.7262 47.2999 97.7262 47.3841V59.389C97.7262 59.4312 97.6843 59.4732 97.6421 59.4732H95.3675C95.3254 59.4732 95.2832 59.4312 95.2832 59.389V43.5931C95.2832 43.5755 95.2904 43.5579 95.3019 43.5434C95.3056 43.5389 95.3097 43.5347 95.3141 43.5308L95.3215 43.5249L95.3282 43.5204C95.3404 43.5132 95.354 43.5089 95.3675 43.5089H98.8214C98.8636 43.5089 98.9058 43.5089 98.9058 43.551L100.801 49.743C100.822 49.7851 100.854 49.8062 100.885 49.8062C100.917 49.8063 100.949 49.7852 100.97 49.743L102.865 43.551C102.865 43.551 102.878 43.5386 102.896 43.5272L102.906 43.5214C102.919 43.5143 102.934 43.5089 102.95 43.5089H106.403Z",
    fill: "#CACACA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.316 43.5113L169.308 43.5139C169.302 43.5159 169.297 43.518 169.293 43.5206L169.287 43.5237C169.265 43.5358 169.25 43.551 169.25 43.551L167.355 49.743C167.312 49.8272 167.228 49.8272 167.186 49.743L165.291 43.551C165.291 43.5089 165.249 43.5089 165.206 43.5089H161.71C161.668 43.5089 161.626 43.551 161.626 43.5931V59.389C161.626 59.4312 161.668 59.4732 161.71 59.4732H163.985C164.027 59.4732 164.069 59.4312 164.069 59.389V47.3841C164.069 47.367 164.074 47.3517 164.083 47.3388C164.094 47.3217 164.112 47.3088 164.131 47.302C164.17 47.2883 164.215 47.2974 164.238 47.3421L166.133 53.5761L166.259 53.9973C166.259 54.0061 166.261 54.013 166.265 54.0184C166.268 54.0242 166.273 54.0284 166.279 54.0315C166.285 54.0344 166.292 54.0363 166.3 54.0375L166.316 54.0391L166.344 54.0395H168.113C168.127 54.0395 168.142 54.0346 168.154 54.028C168.164 54.0228 168.173 54.0168 168.18 54.0114C168.191 54.0037 168.197 53.9973 168.197 53.9973L168.323 53.5761L170.219 47.3421C170.261 47.2577 170.387 47.2577 170.387 47.3841V59.389C170.387 59.4312 170.43 59.4732 170.472 59.4732H172.746C172.788 59.4732 172.831 59.4312 172.831 59.389V43.5931C172.831 43.551 172.788 43.5089 172.746 43.5089H169.334C169.328 43.5089 169.322 43.5098 169.316 43.5113Z",
    fill: "#CACACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.849 43.5089C139.891 43.5089 139.933 43.551 139.891 43.5931V45.5728C139.891 45.615 139.849 45.6572 139.806 45.6572H135.636V59.389C135.636 59.3947 135.636 59.4003 135.634 59.4059C135.633 59.4111 135.631 59.4163 135.629 59.4212C135.624 59.4312 135.617 59.4404 135.609 59.4484C135.593 59.4634 135.573 59.4732 135.552 59.4732H133.277C133.261 59.4732 133.244 59.4667 133.23 59.4562C133.209 59.44 133.193 59.4145 133.193 59.389V45.6572H129.023C128.998 45.6572 128.974 45.6425 128.957 45.6217C128.953 45.6161 128.949 45.6102 128.946 45.6039C128.942 45.594 128.939 45.5834 128.939 45.5728V43.5931C128.939 43.5711 128.95 43.5491 128.968 43.5331C128.983 43.5185 129.003 43.5089 129.023 43.5089H139.849Z",
    fill: "#CACACA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.328 59.4732H155.392C155.417 59.4732 155.443 59.458 155.459 59.4276C155.469 59.4074 155.476 59.3805 155.476 59.3469L151.18 43.5089C151.18 43.4816 151.162 43.472 151.138 43.4686C151.125 43.4667 151.11 43.4667 151.095 43.4667H148.105C148.085 43.4667 148.065 43.4762 148.049 43.4861C148.032 43.4972 148.021 43.5089 148.021 43.5089L143.724 59.3469C143.724 59.389 143.766 59.4732 143.808 59.4732H145.872C145.914 59.4732 145.956 59.4311 145.956 59.4311L147.22 54.7976C147.22 54.768 147.241 54.7593 147.268 54.7567C147.279 54.7555 147.292 54.7555 147.304 54.7555H151.896C151.914 54.7555 151.933 54.7639 151.948 54.7731C151.967 54.7847 151.98 54.7976 151.98 54.7976L153.244 59.4311C153.244 59.4311 153.261 59.4489 153.285 59.4613C153.298 59.468 153.313 59.4732 153.328 59.4732ZM147.852 52.4809L149.537 46.2889C149.579 46.2047 149.663 46.2047 149.705 46.2889L151.39 52.4809C151.39 52.523 151.348 52.6073 151.306 52.6073H147.978C147.894 52.6073 147.852 52.523 147.852 52.4809Z",
    fill: "#CACACA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.859 59.4732H188.795C188.753 59.4732 188.711 59.4311 188.711 59.4311L187.447 54.7976C187.447 54.7976 187.436 54.7861 187.419 54.7751C187.412 54.7711 187.405 54.7671 187.398 54.7638C187.387 54.7589 187.375 54.7555 187.363 54.7555H182.772C182.754 54.7555 182.737 54.7555 182.723 54.7583C182.702 54.7624 182.687 54.7725 182.687 54.7976L181.424 59.4311C181.424 59.4311 181.411 59.4437 181.393 59.4551C181.377 59.4646 181.359 59.4732 181.339 59.4732H179.275C179.233 59.4732 179.191 59.389 179.191 59.3469L183.488 43.5089C183.488 43.5089 183.53 43.4667 183.572 43.4667H186.563C186.586 43.4667 186.609 43.4667 186.625 43.4735C186.638 43.4792 186.647 43.4896 186.647 43.5089L190.943 59.3469C190.943 59.4311 190.901 59.4732 190.859 59.4732ZM185.004 46.2889L183.319 52.4809C183.319 52.523 183.361 52.6073 183.446 52.6073H186.773C186.815 52.6073 186.857 52.523 186.857 52.4809L185.173 46.2889C185.13 46.2047 185.046 46.2047 185.004 46.2889Z",
    fill: "#CACACA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.755 57.1144V52.2282C115.755 52.1861 115.797 52.144 115.839 52.144H121.947C121.966 52.144 121.985 52.135 122.001 52.1214C122.019 52.1052 122.031 52.0825 122.031 52.0598V50.08C122.031 50.0379 121.989 49.9957 121.947 49.9957H115.839C115.797 49.9957 115.755 49.9536 115.755 49.9115V45.7414C115.755 45.717 115.769 45.6927 115.788 45.6766C115.795 45.6715 115.802 45.6671 115.809 45.6638C115.819 45.6595 115.829 45.6572 115.839 45.6572H122.747C122.789 45.6572 122.831 45.615 122.831 45.5728V43.5931C122.831 43.551 122.789 43.5089 122.747 43.5089H113.396C113.354 43.5089 113.312 43.551 113.312 43.5931V59.389C113.312 59.4074 113.32 59.4258 113.332 59.4407C113.349 59.4599 113.372 59.4732 113.396 59.4732H123.042C123.084 59.4732 123.126 59.4312 123.126 59.389V57.3251C123.126 57.2829 123.084 57.2408 123.042 57.2408H115.797C115.797 57.2198 115.786 57.1987 115.776 57.1776C115.765 57.1565 115.755 57.1354 115.755 57.1144Z",
    fill: "#CACACA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M217.312 51.133L225.231 59.3048C225.273 59.3469 225.231 59.4732 225.104 59.5575H222.198L222.156 59.5154L215.332 52.4388C215.29 52.3546 215.206 52.3967 215.206 52.4809V59.4311C215.206 59.4732 215.164 59.5154 215.121 59.5154H212.847C212.805 59.5154 212.763 59.4732 212.763 59.4311V43.6352C212.763 43.6034 212.787 43.5715 212.817 43.5578C212.826 43.5534 212.837 43.5509 212.847 43.5509H215.164C215.206 43.5509 215.248 43.5931 215.248 43.6352V49.7851C215.248 49.8272 215.332 49.8693 215.374 49.8272L221.44 43.5089C221.44 43.4667 221.44 43.4667 221.482 43.4667H224.388C224.415 43.4667 224.442 43.501 224.447 43.5366C224.45 43.557 224.446 43.5778 224.431 43.5931L217.312 51.0066C217.27 51.0488 217.27 51.0909 217.312 51.133Z",
    fill: "#CACACA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.656 35L65.8398 45.2779L68.4093 39.2122L79.656 35Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7275 35L61.4594 45.3621L59.0163 39.2122L47.7275 35Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6853 58.7988L70.9785 64.4432L78.8975 66.6336L81.13 58.9252L74.6853 58.7988Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2959 58.9252L48.5284 66.6336L56.4053 64.4432L52.7406 58.7988L46.2959 58.9252Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9824 49.2794L53.792 52.607L61.5846 52.944L61.3319 44.5195L55.9824 49.2794Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4421 49.2796L66.0083 44.4355L65.8398 52.9443L73.6325 52.6073L71.4421 49.2796Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4043 64.4437L61.122 62.1691L57.0361 58.9678L56.4043 64.4437Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3037 62.1691L70.9793 64.4437L70.3475 58.9678L66.3037 62.1691Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9793 64.4436L66.3037 62.1689L66.6828 65.2018L66.6407 66.5076L70.9793 64.4436Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4043 64.4436L60.785 66.5076L60.7429 65.2018L61.122 62.1689L56.4043 64.4436Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8695 56.9449L56.9521 55.8076L59.6901 54.5439L60.8695 56.9449Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5557 56.9449L67.693 54.5439L70.473 55.8076L66.5557 56.9449Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4049 64.4432L57.0788 58.7988L52.7402 58.9252L56.4049 64.4432Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3467 58.7988L70.9785 64.4432L74.6853 58.9252L70.3467 58.7988Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6325 52.6074L65.8398 52.9444L66.5559 56.946L67.6932 54.5451L70.4733 55.8087L73.6325 52.6074Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9512 55.8087L59.6891 54.5451L60.8686 56.946L61.5846 52.9444L53.792 52.6074L56.9512 55.8087Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.792 52.6074L57.0354 58.9679L56.9512 55.8087L53.792 52.6074Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M70.473 55.8087L70.3467 58.9679L73.6322 52.6074L70.473 55.8087Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5852 52.9443L60.8691 56.946L61.7537 61.7058L61.9643 55.4296L61.5852 52.9443Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8391 52.9443L65.46 55.4296L65.6285 61.7058L66.5551 56.946L65.8391 52.9443Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5556 56.9459L65.6289 61.7057L66.3029 62.1691L70.3466 58.9678L70.473 55.8086L66.5556 56.9459Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9521 55.8086L57.0364 58.9678L61.1223 62.1691L61.7541 61.7057L60.8695 56.9459L56.9521 55.8086Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M66.64 66.5083L66.6822 65.2025L66.3031 64.9077H61.0799L60.7429 65.2025L60.785 66.5083L56.4043 64.4443L57.9207 65.708L61.0378 67.8563H66.3452L69.4622 65.708L70.9786 64.4443L66.64 66.5083Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3023 62.1694L65.6284 61.7061H61.7531L61.1213 62.1694L60.7422 65.2022L61.0792 64.9074H66.3023L66.6814 65.2022L66.3023 62.1694Z",
    fill: "#322F2F",
    stroke: "#322F2F",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2462 45.9518L81.4257 40.2653L79.6565 35L66.3037 44.9409L71.4426 49.2795L78.6877 51.3856L80.2883 49.5322L79.6144 49.0268L80.7096 48.0158L79.8671 47.3419L80.9623 46.4994L80.2462 45.9518Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40.2653L47.1794 45.9518L46.4212 46.4994L47.5164 47.3419L46.674 48.0158L47.8113 49.0268L47.0952 49.5322L48.6958 51.3856L55.983 49.2795L61.1219 44.9409L47.727 35L46 40.2653Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6869 51.3864L71.4419 49.2803L73.6322 52.6079L70.3467 58.9684L74.6853 58.9263H81.13L78.6869 51.3864Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9841 49.2803L48.6969 51.3864L46.2959 58.9263H52.7406L57.0371 58.9684L53.7937 52.6079L55.9841 49.2803Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8395 52.9438L66.3028 44.9406L68.4089 39.2119H59.0156L61.1217 44.9406L61.5851 52.9438L61.7536 55.4712V61.7053H65.6288V55.4712L65.8395 52.9438Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.421224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/Metamask.24a4a2dc9fc1916d1f43d3526564f822.svg";
export { ForwardRef as ReactComponent };